import {Component} from '@angular/core';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {SalesCpiAsideState} from '../../../../../../state/sales-cpi/sales-cpi-aside.state';

@Component({
    selector: 'app-cpi-personal-data-aside',
    templateUrl: './cpi-personal-data-aside.component.html',
})
export class CpiPersonalDataAsideComponent {

    @SelectSnapshot(SalesCpiAsideState.step) step: number;

}
